// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__1AMK8","container":"styles_container__33HIU","title":"styles_title__1dnPW","promos":"styles_promos__1__xJ"};